import { isAllowedUri } from '@tiptap/extension-link';

// Markdown decodes HTML entities in link targets, so `javascript&#58;` must be checked as `javascript:`
const decodeEntities = (text) =>
	new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;

const isSafeUrl = (url) => Boolean(isAllowedUri(decodeEntities(url)));

// `[text](url)` and `![alt](url)`, with or without angle brackets around the url
const INLINE_LINK_REGEX = /\]\(\s*<?([^)\s>]*)/g;
// Reference definitions on their own line: `[label]: url`
const REFERENCE_DEFINITION_REGEX = /^([ \t]*\[[^\]]+\]:[ \t]*)<?([^\s>]*)>?/gm;

/**
 * Blanks link targets that Tiptap's Link extension wouldn't allow (e.g. `javascript:`).
 * The editor already renders these with an empty href, but getMarkdown() still writes the
 * original target, and text typed as `[text](javascript:...)` is saved as real link syntax.
 *
 * @param {string} markdown
 * @returns {string} The markdown with unsafe link targets removed.
 */
export const removeUnsafeMarkdownLinks = (markdown) =>
	markdown
		.replace(INLINE_LINK_REGEX, (match, url) => (isSafeUrl(url) ? match : match.replace(url, '')))
		.replace(REFERENCE_DEFINITION_REGEX, (match, prefix, url) =>
			isSafeUrl(url) ? match : prefix,
		);
